export default class VerticalTabController {
  /* @ngInject */
  constructor($log, ConfigurationService, DictionaryService, ModalService) {
    this.$log = $log;
    this.authorable = ConfigurationService.getConfiguration();
    this.activeTabs = {
      active: null
    };
    this.activeLink = {};
    this.tabs = {};
    this.solutionDictionaryLookup = DictionaryService.solutionDictionaryLookup;

    this.parentsWithCheckedChildren = {};
    this.ModalService = ModalService;
    this.solutionList = [];
    this.selectedSolutions = false;
    this.DictionaryService = DictionaryService;
  }

  $onInit() {
    const firstTab = this.tabs[0];
    this.setActiveTab(firstTab);
    this.tabs.forEach((tab) => {
      const firstParentSolution = this.authorable[tab.key][0];
      this.setActiveLink(firstParentSolution, tab);
    });
  }

  open(parentSolution) {
    // used when calling the modal service
    const formData = this.formData;
    const resolves = {
      parentSolution() {
        return parentSolution;
      },
      formData() {
        return formData;
      }
    };
    this.ModalService.invokeModal('solutionLightbox', resolves)
      .then((parentSolutionInfo) => {
        if (parentSolutionInfo) {
          const solutionsFromModal = parentSolutionInfo.lightboxFormData.solutions;
          const formDataSolutions = this.formData.solutions || {};
          if (solutionsFromModal) {
            Object.keys(solutionsFromModal)
              .forEach((solution) => {
                if (solutionsFromModal[solution]) {
                  formDataSolutions[solution] = true;
                } else if (formDataSolutions[solution]) {
                  delete formDataSolutions[solution];
                }
              });
            this.formData.solutions = angular.equals(formDataSolutions, {}) ?
              {} : formDataSolutions;

            // update the invalid class on solution pickers
            if (angular.equals(formDataSolutions, {})) {
              this.setNoSolutionSelected({ bool: true });
            } else if (this.setInvalidClassOnSolutions) {
              this.setNoSolutionSelected({ bool: false });
            }
          }
        }
      });
  }

  setActiveTab(activeTab) {
    this.activeTabs.active = activeTab.key;
  }

  setActiveLink(parentSolution, tab) {
    this.activeLink[tab.key] = parentSolution.key;
  }

  getSelectedSolutionList() {
    return Object.keys(this.formData.solutions);
  }

  solutionsAreSelected() {
    return angular.isDefined(this.formData.solutions) &&
      Object.keys(this.formData.solutions).length > 0;
  }

  solutionLookup(solution) {
    return this.DictionaryService.solutionDictionaryLookup(solution, 'name');
  }

  deleteSolution(solutionKey) {
    if (this.formData.solutions[solutionKey]) {
      delete this.formData.solutions[solutionKey];
    }
  }

  clearAllSolutions() {
    this.formData.solutions = {};
  }
}



// WEBPACK FOOTER //
// ./src/components/search-form/vertical-tab/verticalTab.controller.js